<template>
    <van-popup v-model="show" position="bottom" :style="{ height: '500px' }" closeable>
            <h3 class="choose-title">选择课题亚专业标签</h3>
            <div class="tags flex">
                <div class="left">
                    <p v-for="(item,index) in tags" :key="index" @click="chooseFirst(index)" :class="active==index?'active':''">{{item.name}}</p>
                </div>
                <div class="right" v-if="tags[active]">
                    <p :class="subactive==index?'active':''" v-for="(item,index) in tags[active].child" :key="index" @click="chooseSecond(index)">{{item.name}}<img v-if="subactive==index" src="@/assets/images/collection/tick.png"></p>
                </div>

            </div>
    </van-popup>
</template>

<script>
export default {
    props:{
        tags:Array,
        f_tag_id:Number,
        s_tag_id:Number
    },
    data(){
        return{
            active:0,
            subactive:0,
            show:false
        }
    },
    watch:{
        f_tag_id(newVal,oldVal){
            this.tags.forEach((item,index)=>{
                if(item.id==newVal){
                    this.active=index;
                }
            })

        },
        s_tag_id(newVal,oldVal){
            if(this.tags[this.active]){
                this.tags[this.active].child.forEach((item,index)=>{
                    if(item.id==newVal){
                        this.subactive=index;
                    }
                })
            }
        }
    },
    methods:{
        changeShowFlag(){
            this.show=!this.show;
        },
         chooseFirst(index){
            if(this.active!=index){
                this.active=index;
                this.subactive=0;
                this.$emit('changeValue',this.active,this.subactive);
            }
        },
        chooseSecond(index){
            if(this.subactive!=index){
                this.subactive=index;
                this.$emit('changeValue',this.active,this.subactive);
            }
        },

    }

}
</script>

<style lang="scss" scoped>
.choose-title{
        text-align: center;
            height:55px;
            font-size: 20px;
            line-height: 55px;
            background-color: #F5F6F7;
            font-weight: 440;
            // margin-top: -48px;
    }
    .tags{
        .left{
            width:35%;
            background-color: white;
            p{
                padding:17px 20px;
                //  line-height: 60px;
                color: #B5B5B5;
                font-size: 17px;
                background-color: #F5F6F7;
                
            }
            .active{
                color: #B01C06;
                font-size: 17px;
                background-color: white;

            }
        }
        .right{
            width: 65%;
            padding-left: 20px;
            background-color: white;
            p{
                height: 60px;
                line-height: 60px;
                color: black;
                font-size: 17px;
                border-bottom: 1px solid #F9F9F9;
            }
            .active{
                color: #B01C06;
                font-size: 18px;
                img{
                    height: 30px;
                    float: right;
                    margin-top: 15px;
                    margin-right: 20px;
                }
            }
        }
    
    }

</style>


// WEBPACK FOOTER //
// src/pages/Contributions/components/tag.vue